import { render, staticRenderFns } from "./package_form.vue?vue&type=template&id=01bff04a&"
import script from "./package_form.vue?vue&type=script&lang=js&"
export * from "./package_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports